/**
 * Field Labels Configuration
 * 
 * Maps field keys to human-readable labels based on json_info.txt
 * Used for displaying annotation data in a user-friendly format
 */

export const fieldLabels = {
  "186": "Z - Gem. Kd gew",
  "187": "Z - Gem. Ham P2",
  "188": "Z - Gem. Ham Mx",
  "189": "Z - Gem. Vle P2",
  "190": "Z - Gem. Spk P2",
  "191": "Z - Gem. SP 3.4",
  "192": "Z - Gem. VLD 3.4",
  "193": "Z - Gem. Vlees %",
  "194": "Z - Gem. Kar COG",
  "195": "Z - Gem. AFI/MBI",
  "196": "Z - Gem. Gew tsl",
  "197": "Z - Gem. Lab tsl",
  "198": "Z - Gem. Tot prs",
  "216": "M - Gem. Kd gew",
  "217": "M - Gem. Ham P2",
  "218": "M - Gem. Ham Mx",
  "219": "M - Gem. Vle P2",
  "220": "M - Gem. Spk P2",
  "221": "M - Gem. SP 3.4",
  "222": "M - Gem. VLD 3.4",
  "223": "M - Gem. Vlees %",
  "224": "M - Gem. Kar COG",
  "225": "M - Gem. AFI/MBI",
  "226": "M - Gem. Gew tsl",
  "227": "M - Gem. Lab tsl",
  "228": "M - Gem. Tot prs",
  "232": "Tot Z",
  "233": "Tot M",
  "234": "Tot Totaal",
  "236": "Gem. Kd gew",
  "237": "Gem. Ham P2",
  "238": "Gem. Ham Mx",
  "239": "Gem. Vle P2",
  "240": "Gem. Spk P2",
  "241": "Gem. SP 3.4",
  "242": "Gem. VLD 3.4",
  "243": "Gem. Vlees %",
  "244": "Gem. Kar COG",
  "245": "Gem. AFI/MBI",
  "246": "Gem. Gew tsl",
  "247": "Gem. Lab tsl",
  "248": "Gem. Tot prs",
  "250": "Field 250",
  "251": "Field 251",
  "252": "Field 252",
  "253": "Field 253",
  "254": "Field 254",
  "255": "Field 255",
  "256": "Field 256",
  "261": "Tot B",
  "262": "Tot P",
  "271": "PK",
  "272": "Aantal Z",
  "273": "Aantal M",
  "274": "Totaal aantal per PK",
  "275": "%",
  "276": "Koud gewicht",
  "277": "Gem. Waarden - Ham P2",
  "278": "Gem. Waarden - Ham Mx",
  "279": "Gem. Waarden - Vle P2",
  "280": "Gem. Waarden - Spk P2",
  "281": "Gem. Waarden - SP 3.4",
  "282": "Gem. Waarden - VLD 3.4",
  "283": "Gem. Waarden - Vlees %",
  "284": "Gem. Waarden - Kar COG",
  "285": "Gem. Waarden - AFI/MBI",
  "286": "Gem. Waarden - Gew tsl",
  "287": "Gem. Waarden - Lab tsl",
  "288": "Field 288",
  "289": "Aantal B",
  "290": "Aantal P",
  "300": "Field 300",
  "301": "Field 301",
  "302": "Field 302",
  "303": "Field 303",
  "304": "Field 304",
  "305": "Field 305",
  "306": "Field 306",
  "307": "Field 307",
  "308": "Field 308",
  "309": "Field 309",
  "310": "Field 310",
  "311": "Field 311",
  "331": "Field 331",
  "332": "Field 332",
  "333": "Field 333",
  "334": "Field 334",
  "335": "Field 335",
  "336": "Field 336",
  "337": "Field 337",
  "338": "Field 338",
  "339": "Field 339",
  "340": "Field 340",
  "341": "Field 341",
  "342": "Field 342",
  "343": "Field 343",
  "344": "Field 344",
  "345": "Field 345",
  "346": "Field 346",
  "347": "Field 347",
  "348": "Field 348",
  "352": "Field 352",
  "353": "Field 353",
  "354": "Field 354",
  "355": "Field 355",
  "356": "Field 356",
  "357": "Field 357",
  "361": "Field 361",
  "362": "Field 362",
  "506": "B - Gem. Kd gew",
  "507": "B - Gem. Ham P2",
  "508": "B - Gem. Ham Mx",
  "509": "B - Gem. Vle P2",
  "510": "B - Gem. Spk P2",
  "511": "B - Gem. SP 3.4",
  "512": "B - Gem. VLD 3.4",
  "513": "B - Gem. Vlees %",
  "514": "B - Gem. Kar COG",
  "515": "B - Gem. AFI/MBI",
  "516": "B - Gem. Gew tsl",
  "517": "B - Gem. Lab tsl",
  "518": "B - Gem. Tot prs",
  "536": "Z - Gem. Kd gew",
  "537": "Z - Gem. Ham P2",
  "538": "Z - Gem. Ham Mx",
  "539": "Z - Gem. Vle P2",
  "540": "Z - Gem. Spk P2",
  "541": "Z - Gem. SP 3.4",
  "542": "Z - Gem. VLD 3.4",
  "543": "Z - Gem. Vlees %",
  "544": "Z - Gem. Kar COG",
  "545": "Z - Gem. AFI/MBI",
  "546": "Z - Gem. Gew tsl",
  "547": "Z - Gem. Lab tsl",
  "548": "Z - Gem. Tot prs",
  "690": "Field 690",
  "695": "Field 695",
  "700": "Field 700",
  "720": "Field 720",
  "730": "Field 730",
  "3311": "Field 3311",
  "3312": "Field 3312",
  "3313": "Field 3313",
  "3341": "Field 3341",
  "3342": "Field 3342",
  "3343": "Field 3343",
  "3371": "Field 3371",
  "3372": "Field 3372",
  "3373": "Field 3373",
};

/**
 * Get label for a field key
 * Falls back to "Field {key}" if label is not found
 * 
 * @param {string} key - The field key
 * @returns {string} The human-readable label for the field
 */
export const getFieldLabel = (key) => {
  if (fieldLabels[key]) {
    return fieldLabels[key];
  }
  return `Field ${key}`;
};

export default {
  fieldLabels,
  getFieldLabel,
};
